import { render, staticRenderFns } from "./textElementOptions.vue?vue&type=template&id=26110f0a&"
import script from "./textElementOptions.vue?vue&type=script&lang=js&"
export * from "./textElementOptions.vue?vue&type=script&lang=js&"
import style0 from "./textElementOptions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports